import tochtApi from "../../../api/zoekmotor/tochtApi";
import moment from "moment";
import Row from "../../common/Row";
import React, { Fragment } from "react";
import { getIcoonDataUri } from "../../../util/tochtTypeIcoon";

export default class OverzichtDetailHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        let tochtId = this.context.props.match.params.tochtId;

        if (!tochtId) {
            tochtId = this.querystring("tochtid")[0];
        }

        this.getTochtDetail(tochtId);
    }

    getTochtDetail(tochtId) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const loadDetailLayout = context.props.loadDetailLayout;

        ajaxActions.started();
        tochtApi.getTochtDetail(tochtId)
            .then((response) => {
                ajaxActions.ended();
                this.processModel(response);
                loadDetailLayout(this.createTitle(response.data), this.createSubtitle(response.data));
            })
            .catch((ex) => {
                ajaxActions.failed();
                if (ex.response && ex.response.status === 410)
                    context.setState({ isAfgelopen: true });
                else
                    context.props.throwException(ex);
            });
    }

    createTitle(tocht) {
        const federatieLogo = tocht.federatieLogo
            ? <img className="federatie-logo" src={"data:image/png;base64," + tocht.federatieLogo} title="Tocht georganiseerd met goedkeuring van een erkende sportfederatie" alt="Erkende sportfederatie" />
            : null;

        return <Fragment>{tocht.naam}{federatieLogo}</Fragment>;
    }

    createSubtitle(tocht) {
        const tochtTypeIcoon = tocht.tochtTypeIcoonBase64
            ? <img className="tochttype-icoon" src={getIcoonDataUri(tocht.tochtTypeIcoonBase64)} title={tocht.tochtTypeNaam} alt={tocht.tochtTypeNaam} />
            : null;

        return (
            <Row>
                <div className="o-col-3">&nbsp;</div>
                <div className="o-col-2" style={{ textAlign: 'center' }}>{tochtTypeIcoon}</div>
                <div className="o-col-2" style={{ textAlign: 'center' }}>{moment(tocht.datum).format("DD/MM/YYYY")}</div>
                <div className="o-col-2" style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>{tocht.startplaatsGemeente ? `Start in ${tocht.startplaatsGemeente}` : null}</div>
                <div className="o-col-3">&nbsp;</div>
            </Row>
        );
    }

    processModel(response) {
        const context = this.context;
        context.setState({
            model: response.data
        });
    }

    querystring(obj) {
        const result = [];
        let match;
        const re = new RegExp('(?:\\?|&)' + obj + '=(.*?)(?=&|$)', 'gi');
        while ((match = re.exec(document.location.search)) !== null) {
            result.push(match[1]);
        }
        return result;
    }
}